export enum ExternalIntegrationTypeEnum {
    mautic,
    rudderstack,
    email_platform,
    sms_platform,
    ad_platform,
    crm,
    cdp,
    custom
}
